<svelte:options accessors />

<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import { EFieldValidationStatus } from './type';
  interface rule {
    validator: ((_text: string) => boolean) | 'required';
    message?: string;
  }

  export let value = '';
  export let placeholder = '';
  export let disabled = false;
  export let readonly = false;
  export let label = '';
  // 越靠前定义的 rule 错误信息展示的优先级越高，一旦有 false 即不再进行之后的校验
  export let rules: rule[] = [];

  let errMsg = '';

  export const handleValidating = () => {
    if (rules.length === 0) {
      return EFieldValidationStatus.passed;
    }
    // 所有规则通过的情况下 reset
    let msg = '';
    let status: EFieldValidationStatus = EFieldValidationStatus.unvalidated;
    for (const rule of rules) {
      if (rule.validator === 'required' && !value) {
        status = EFieldValidationStatus.failed;
        msg = rule.message || '请填写正确内容';
        // 校验结果已出则不继续进行
        break;
      }
      if (typeof rule.validator === 'function' && !rule.validator(value)) {
        status = EFieldValidationStatus.failed;
        msg = rule.message || '';
        // 校验结果已出则不继续进行
        break;
      }
    }
    if (status === EFieldValidationStatus.unvalidated) {
      status = EFieldValidationStatus.passed;
    }
    errMsg = msg;
    return status;
  };

  const dispatch = createEventDispatcher();
  const handleCompClick = () => {
    dispatch('click');
  };
</script>

<div
  class={`field_ctn ${$$restProps.class}`}
  on:click={handleCompClick}
  on:keyup={handleCompClick}
  role="button"
  tabindex="0"
>
  {#if label}
    <div class="label">
      <label for="">{label}</label>
    </div>
  {/if}
  <div class="field_body">
    <input
      class="input"
      class:disabled
      bind:value
      type="text"
      {placeholder}
      {disabled}
      {readonly}
      on:blur={handleValidating}
    />
    <div class="err_msg">{errMsg}</div>
  </div>
</div>

<style lang="scss">
  .field_ctn {
    display: flex;
    padding: 10px 16px;
    width: 100%;
    font-size: 14px;
    color: #323232;
    line-height: 24px;
    background: #fff;
    border: none;
    box-sizing: border-box;
    overflow: hidden;
  }
  .label {
    flex: 0 0 6.2em;
    margin-right: 12px;
    text-align: left;
    word-wrap: break-word;
  }
  .field_body {
    flex: 1;
    .input {
      margin: 0;
      padding: 0;
      width: 100%;
      font-size: 14px;
      line-height: 24px;
      border: none;
      background-color: transparent;
    }
    .input::placeholder {
      color: #c8c9cc;
    }
    .input:read-only {
      cursor: default;
    }
    .input:focus {
      outline: none;
    }
    .disabled {
      color: #c8c9cc;
      cursor: not-allowed;
      opacity: 1;
      // fix disabled color in mobile safari
      -webkit-text-fill-color: #c8c9cc;
    }
  }
  .err_msg {
    color: #ee0a24;
    font-size: 12px;
    text-align: left;
  }
</style>
